module.exports = __webpack_public_path__ + "static/media/alert.34c73f87.svg";